// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/common/v1/traffic_source.proto" (package "bianka.common.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Channel } from "../../enums/traffic_source/channel";
import { StringValue } from "../../../google/protobuf/wrappers";
/**
 * Next serial number to be used: 15
 *
 * @generated from protobuf message bianka.common.v1.TrafficSource
 */
export interface TrafficSource {
    /**
     * Required. utm_source
     *
     * @generated from protobuf field: google.protobuf.StringValue source = 1;
     */
    source?: StringValue;
    /**
     * Required. utm_medium
     *
     * @generated from protobuf field: google.protobuf.StringValue medium = 2;
     */
    medium?: StringValue;
    /**
     * Required. utm_campaign
     *
     * @generated from protobuf field: google.protobuf.StringValue campaign = 3;
     */
    campaign?: StringValue;
    /**
     * Required. utm_content
     *
     * @generated from protobuf field: google.protobuf.StringValue content = 4;
     */
    content?: StringValue;
    /**
     * Required. utm_term
     *
     * @generated from protobuf field: google.protobuf.StringValue term = 5;
     */
    term?: StringValue;
    /**
     * Required. utm_position
     *
     * @generated from protobuf field: google.protobuf.StringValue publisher_platform = 6;
     */
    publisherPlatform?: StringValue;
    /**
     * Required. utm_placement
     *
     * @generated from protobuf field: google.protobuf.StringValue publisher_position = 7;
     */
    publisherPosition?: StringValue;
    /**
     * Required. another field for utm_placement
     *
     * @generated from protobuf field: google.protobuf.StringValue placement = 8;
     */
    placement?: StringValue;
    /**
     * Required. Adwords campaign
     *
     * @generated from protobuf field: google.protobuf.StringValue campaign_id = 9;
     */
    campaignId?: StringValue;
    /**
     * Required. Adwords ad group id
     *
     * @generated from protobuf field: google.protobuf.StringValue ad_group_id = 10;
     */
    adGroupId?: StringValue;
    /**
     * Required. Adwords ad id
     *
     * @generated from protobuf field: google.protobuf.StringValue ad_id = 11;
     */
    adId?: StringValue;
    /**
     * Required. Google click id
     *
     * @generated from protobuf field: google.protobuf.StringValue gclid = 12;
     */
    gclid?: StringValue;
    /**
     * Required. MSCLKID click id
     *
     * @generated from protobuf field: google.protobuf.StringValue click_id = 13;
     */
    clickId?: StringValue;
    /**
     * Required. Type of marketing channel
     *
     * @generated from protobuf field: bianka.enums.traffic_source.Channel channel = 14;
     */
    channel: Channel;
}
// @generated message type with reflection information, may provide speed optimized methods
class TrafficSource$Type extends MessageType<TrafficSource> {
    constructor() {
        super("bianka.common.v1.TrafficSource", [
            { no: 1, name: "source", kind: "message", T: () => StringValue },
            { no: 2, name: "medium", kind: "message", T: () => StringValue },
            { no: 3, name: "campaign", kind: "message", T: () => StringValue },
            { no: 4, name: "content", kind: "message", T: () => StringValue },
            { no: 5, name: "term", kind: "message", T: () => StringValue },
            { no: 6, name: "publisher_platform", kind: "message", T: () => StringValue },
            { no: 7, name: "publisher_position", kind: "message", T: () => StringValue },
            { no: 8, name: "placement", kind: "message", T: () => StringValue },
            { no: 9, name: "campaign_id", kind: "message", T: () => StringValue },
            { no: 10, name: "ad_group_id", kind: "message", T: () => StringValue },
            { no: 11, name: "ad_id", kind: "message", T: () => StringValue },
            { no: 12, name: "gclid", kind: "message", T: () => StringValue },
            { no: 13, name: "click_id", kind: "message", T: () => StringValue },
            { no: 14, name: "channel", kind: "enum", T: () => ["bianka.enums.traffic_source.Channel", Channel, "CHANNEL_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message bianka.common.v1.TrafficSource
 */
export const TrafficSource = new TrafficSource$Type();
